/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: downloadsearchform.js
 */
$.namespace("SCS.downloadsearchform");


SCS.downloadsearchform.defaultSelectorAppender = "$";

SCS.downloadsearchform.searchType = "";
SCS.downloadsearchform.searchFormName = "";

SCS.downloadsearchform.searchKeywordDefaultText = "";
SCS.downloadsearchform.isAjaxRequest = false;
SCS.downloadsearchform.manufacturerDefaultText = "";
SCS.downloadsearchform.productDefaultText = "";

SCS.downloadsearchform.setI18nEntries = function(searchInstructionI18n, manufacturerI18n, productI18n) {
	SCS.downloadsearchform.searchKeywordDefaultText = searchInstructionI18n;
	SCS.downloadsearchform.manufacturerDefaultText = manufacturerI18n;
	SCS.downloadsearchform.productDefaultText = productI18n;
};

SCS.downloadsearchform.populateManufacturerTags = function(json) {
	var productFamilyTagValue = $("#productFamilyTag_" + SCS.downloadsearchform.searchType).val();
	var manufacturerTagInRequest = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var dropdownDisabled = '';
	if (productFamilyTagValue == null || productFamilyTagValue == '') {
		dropdownDisabled = 'disabled';
	}

	var productTagsDefaultHtml = '';
	var labelManufacturer = $("#productFamilyTag_" + SCS.downloadsearchform.searchType
		+ " option:selected").text();
	if (productFamilyTagValue == "") {
		labelManufacturer = "";
	}
	else if (SCS.utils.isMobilePage() == true) {
		$("#productFamilyTag_" + SCS.downloadsearchform.searchType).siblings('span').html(labelManufacturer);
	}

	var textX = SCS.downloadsearchform.manufacturerDefaultText.replace("{0}", labelManufacturer);

	var labelProduct = '';
	var textY = SCS.downloadsearchform.productDefaultText.replace("{0}", labelProduct);
	
	if (SCS.utils.isMobilePage() == true) {
		productTagsDefaultHtml = '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
			+ '" data-theme="secondary-button">';
	}
	else {
		productTagsDefaultHtml = '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
		+ '" size="8" disabled>';
	}
	productTagsDefaultHtml += '<option title="' + textY + '" value="">' + textY + '</option>';
	productTagsDefaultHtml += '</select>';
	var productFamilyTag = json.tags[productFamilyTagValue];

	$('#manufacturerTags').empty();
	var manufacturerDropDown = '';

	if (SCS.utils.isMobilePage() == true) {
		manufacturerDropDown += '<select name="m" id="manufacturerTag_'
			+ SCS.downloadsearchform.searchType
			+ '" data-theme="secondary-button" onchange="SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags); ">';
	}
	else {
		manufacturerDropDown += '<select name="m" id="manufacturerTag_'
			+ SCS.downloadsearchform.searchType
			+ '" size="8" onchange="SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags); "'
			+ dropdownDisabled + '>';
	}
	manufacturerDropDown += '<option title="' + textX + '" value="">' + textX + '</option>';

	var id = "";
	var title = "";
	var lmfText = textX;
	for ( var manufacturerTagKey in productFamilyTag) {
		if (productFamilyTag.hasOwnProperty(manufacturerTagKey)) {
			id = productFamilyTag[manufacturerTagKey].id;
			title = productFamilyTag[manufacturerTagKey].title;
			count = productFamilyTag[manufacturerTagKey].results;
			if (manufacturerTagInRequest == id) {
				if (count != "" && count != "0") {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					manufacturerDropDown += '<option class="greytext" title="' + title
						+ '" value=\"' + id + '\" selected>' + title + ' (' + count + ')</option>';
				} else {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + '</option>';
				}
				lmfText = title;
			} else {
				if (count != "" && count != "0") {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					manufacturerDropDown += '<option class="greytext" title="' + title
						+ '" value=\"' + id + '\">' + title + ' (' + count + ')</option>';
				} else {
					manufacturerDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + '</option>';
				}

			}
		}
	}
	manufacturerDropDown += '</select>';
	
	$('#manufacturerTags').html(manufacturerDropDown);
	$('#productTags').html(productTagsDefaultHtml);
	if (SCS.utils.isMobilePage() == true) {
		$('#manufacturerTags').trigger("create");
		$('#productTags').trigger("create");
	}
}

SCS.downloadsearchform.populateProductTags = function(json) {
	var labelProduct = null;
	var manufacturerTagValue = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var valManuf = $("#manufacturerTag_" + SCS.downloadsearchform.searchType + " option:selected")
		.val();
	var valProdFamily = $("#productFamilyTag_" + SCS.downloadsearchform.searchType
		+ " option:selected").val();

	if (valProdFamily && valManuf) {
		labelProduct = SCS.downloadsearchform.manufacturerTags.tags[valProdFamily][valManuf].title;
	}

	if (labelProduct == null) {
		labelProduct = $("#manufacturerTag_" + SCS.downloadsearchform.searchType
			+ " option:selected").text();
	}

	if (manufacturerTagValue == "") {
		labelProduct = "";
	}
	else if (SCS.utils.isMobilePage() == true) {
		$("#manufacturerTag_" + SCS.downloadsearchform.searchType).siblings('span').html(labelProduct);
	}
	
	var textY = SCS.downloadsearchform.productDefaultText.replace("{0}", labelProduct);
	var dropdownDisabled = '';
	if (manufacturerTagValue == null || manufacturerTagValue == '') {
		dropdownDisabled = 'disabled';
	}
	var manufacturerTag = json.tags[manufacturerTagValue];

	$('#productTags').empty();
	var productDropDown = '';
	var productTagInRequest = $("#product").val();
	if (SCS.utils.isMobilePage() == true) {
		productDropDown += '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
		+ '"data-theme="secondary-button">';
	}
	else {
		productDropDown += '<select name="p" id="productTag_' + SCS.downloadsearchform.searchType
			+ '" size="8" ' + dropdownDisabled + '>';
	}
	productDropDown += '<option title="' + textY + '" value="">' + textY + '</option>';
	var id = "";
	var title = "";
	var lmfText = textY;
	for ( var productTagKey in manufacturerTag) {
		if (manufacturerTag.hasOwnProperty(productTagKey)) {
			id = manufacturerTag[productTagKey].id;
			title = manufacturerTag[productTagKey].title;
			count = manufacturerTag[productTagKey].results;
			if (productTagInRequest == id) {
				if (count != "" && count != "0") {
					productDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					productDropDown += '<option class="greytext" title="' + title + '" value=\"'
						+ id + '\" selected>' + title + ' (' + count + ')</option>';
				} else {
					productDropDown += '<option title="' + title + '" value=\"' + id
						+ '\" selected>' + title + '</option>';
				}
				lmfText = title;
			} else {
				if (count != "" && count != "0") {
					productDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + ' (' + count + ')</option>';
				} else if (count != "" && count == "0") {
					productDropDown += '<option class="greytext" title="' + title + '" value=\"'
						+ id + '\">' + title + ' (' + count + ')</option>';
				} else {
					productDropDown += '<option title="' + title + '" value=\"' + id + '\">'
						+ title + '</option>';
				}
			}
		}
	}
	productDropDown += '</select>';
	
	$('#productTags').html(productDropDown);
	if (SCS.utils.isMobilePage() == true) {
		$('#productTags').trigger("create");
	}
	
	if (SCS.utils.isMobilePage() == true) {
		$('#productTags select').off('change').on('change', function() {
			$(this).siblings('span').html($('option:selected', $(this)).text());
		});
	}
	
}

var searchKeyword;

/**
 * Replace all function
 * WARNING: dangerous function - if find-text is contained in replacement-text,
 * it will re-replace within
 * @param text Text
 * @param find String to find
 * @param repl Replacement string
 */
SCS.downloadsearchform.replaceAll = function(text, find, repl) {
	var newText = text;
	if (newText) {
		var i = 0;
		while (newText.indexOf(find) != -1 && i < 20) {
			newText = newText.replace(find, repl);
			i++;
		}
	}
	return newText;
};

SCS.downloadsearchform.sendRequest = function(searchType) {
	SCS.downloadsearchresults.clientSideValidation = false;
	searchKeyword = $("#search").val();
	if (this.isAjaxRequest)
		return;

	if (searchKeyword == SCS.downloadsearchform.searchKeywordDefaultText) {
		searchKeyword = "";
	}
	window.location.href = SCS.downloadsearchform.buildUrl(searchType);
	return false;
};

SCS.downloadsearchform.sendRequestSuggestedKeyword = function(keyword) {
	SCS.downloadsearchresults.clientSideValidation = false;
	searchKeyword = $("#suggestedKeyword").val();
	window.location.href = SCS.downloadsearchform.buildUrl('searchForm');
	location.reload();
	return false;
};

SCS.downloadsearchform.buildUrl = function(searchType) {
	var productFamilyTagValue = $("#productFamilyTag_" + SCS.downloadsearchform.searchType).val();
	var manufacturerTagValue = $("#manufacturerTag_" + SCS.downloadsearchform.searchType).val();
	var productTagValue = $("#productTag_" + SCS.downloadsearchform.searchType).val();
	if (productFamilyTagValue == null) {
		productFamilyTagValue = '';
	}
	productFamilyTagValue = SCS.downloadsearchform.defaultSelectorAppender + productFamilyTagValue;

	if (manufacturerTagValue == null) {
		manufacturerTagValue = '';
	}
	manufacturerTagValue = SCS.downloadsearchform.defaultSelectorAppender + manufacturerTagValue;

	if (productTagValue == null) {
		productTagValue = '';
	}
	productTagValue = SCS.downloadsearchform.defaultSelectorAppender + productTagValue;

	searchKeyword = SCS.downloadsearchform.defaultSelectorAppender + jQuery.trim(searchKeyword);

	searchKeyword = SCS.downloadsearchform.replaceAll(searchKeyword, '.', ' ');

	manufacturerTagValue = SCS.downloadsearchform.replaceAll(manufacturerTagValue, '/', ':');

	productTagValue = SCS.downloadsearchform.replaceAll(productTagValue, '/', ':');

	/*
	 * Defect ID-8681 . Functioning of component as two different components .
	 * Selectors should be changed to achieve this based on searchType .
	 */
	var selectors = "";
	if (searchType == 'searchForm') {
		selectors = "#." + searchKeyword + "." + productFamilyTagValue + "." + manufacturerTagValue
			+ "." + productTagValue;

	} else if (searchType == 'both') {
		selectors = "#." + searchKeyword + "." + productFamilyTagValue + "." + manufacturerTagValue
			+ "." + productTagValue;

	} else {
		selectors = "#." + "$." + productFamilyTagValue + "." + manufacturerTagValue + "."
			+ productTagValue;
	}

	var url = $('#' + SCS.downloadsearchform.searchFormName).attr('action');

	return url + ".html" + selectors;
};

SCS.downloadsearchform.init = function() {
	$(window).on('hashchange', function() {
		if (!SCS.downloadsearchresults.clientSideValidation) {
			$(document).trigger("downloadSearchEvent", [ location.hash ]);
			$(document).trigger("downloadSearchFormEvent", [ location.hash ]);
		}
		// get data back from hash :)
//		SCS.header.changeheaderurl("de");
//		SCS.header.changeheaderurl("en");
//		SCS.header.changeheaderurl("fr");
//		SCS.header.changeheaderurl("it");

	});
	$(document).on("downloadSearchFormEvent", function(event, selector) {
		if (selector != undefined && selector != '') {
			selector = unescape(selector);
			var selector1 = selector.replace('#', '');
			var ss = selector1.split(".");
			if (ss[1] != undefined) {
				var keyword = ss[1].replace('$', '');
				if (keyword != '') {
					$("#search").val(keyword);
				}
			}
			if (ss[2] != undefined) {
				var productFamily = ss[2].replace('$', '');
				if (productFamily != '') {
					$("#productFamilyTag_" + SCS.downloadsearchform.searchType).val(productFamily);
				}
			}

			if (ss[3] != undefined) {
				SCS.downloadsearchform
					.populateManufacturerTags(SCS.downloadsearchform.manufacturerTags)
				var manufacturer = ss[3].replace('$', '');
				manufacturer = manufacturer.replace(productFamily + ":", productFamily + "/");
				if (manufacturer != '') {
					$("#manufacturerTag_" + SCS.downloadsearchform.searchType).val(manufacturer);
				}
			}

			if (ss[4] != undefined) {
				SCS.downloadsearchform.populateProductTags(SCS.downloadsearchform.productTags)
				var product = ss[4].replace('$', '');
				var manufacturer1 = ss[3].replace('$', '');
				product = product.replace(manufacturer1 + ":", manufacturer + "/");
				product = product.replace('+', ' ');
				if (product != '') {
					$("#productTag_" + SCS.downloadsearchform.searchType).val(product);
				}
			}

		}

	});

	$(document).ready(function() {

		if (location.hash.length > 0) {
			$(window).trigger('hashchange');
		}
	});

};

SCS.downloadsearchform.showAjaxLoader = function() {

	var windowWidth = $(window).width();
	var windowHeight = $(window).height();
	var barWidth = $("#processingBar").width();
	var barHeight = $("#processingBar").height();

	$("#processingBar").css({
		top : ((windowHeight / 2) - (barHeight / 2)),
		left : ((windowWidth / 2) - (barWidth / 2))
	});

	$("#processingBarPanel").css({
		width : windowWidth,
		height : windowHeight
	});

	$("#processingBarPanel").show();
	$("#processingBar").show();
};

SCS.downloadsearchform.hideAjaxLoader = function() {
	$("#processingBarPanel").hide();
	$("#processingBar").hide();
};

SCS.downloadsearchform.showCarousel = function() {
	$("#scs-devicecarousel").show();
	if ($("div.basic-carousel:visible") != undefined) {
		$("div.basic-carousel:visible").each(function() {
			SCS.devicecarousel.init(this.id);
		});
	}
};

SCS.downloadsearchform.hideCarousel = function() {
	$("#scs-devicecarousel").hide();
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadsearchform.js
// module id = 338
// module chunks = 0